import React, { useContext } from "react";
import {
  Link,
  UncustomizableMarkup,
  Typography,
  FlexBox,
  Button,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
} from "@vp/swan";
import MemoizedReactMarkdown from "../../../../components/MemoizedReactMarkdown";
import TrackingUtil from "../../../../utils/tracking";
import { PluginDataContext } from "../../../../pluginsInfrastructure/PluginDataContextProvider";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";

export const ShippingExclusion = () => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const { pluginData } = useContext(PluginDataContext);
  const { mpv } = useContext(PageStaticDataContext);
  const { mpvId } = mpv;

  const shippingContent = pluginData.contentful["shippingInformation"].value;
  const shippingExclusion = pluginData.contentful["shippingExclusion"];
  const dismissAlert = pluginData.contentful["dismissAlert"];

  if (!shippingContent || !shippingExclusion) {
    return <></>;
  }

  return (
    <FlexBox justifyContent="flex-start">
      <Link
        render={p => (
          <Button
            skin="link"
            className={p.className}
            onClick={() => {
              setIsDialogOpen(true);
              TrackingUtil.trackDeliveryOptionsEvent(true, mpvId);
            }}
            marginY="0"
          >
            {p.children}
          </Button>
        )}
      >
        <Typography
          className="shipping-exclusion-text"
          fontSize={"small"}
          textAlign="right"
          as="span"
        >
          {shippingExclusion}
        </Typography>
      </Link>
      <ModalDialog
        isOpen={isDialogOpen}
        onRequestDismiss={() => {
          setIsDialogOpen(false);
          TrackingUtil.trackDeliveryOptionsEvent(false, mpvId);
        }}
        variant="panel-right"
      >
        <ModalDialogContent>
          <ModalDialogNav>
            <ModalDialogCloseButton visuallyHiddenLabel={dismissAlert} />
          </ModalDialogNav>
          <ModalDialogBody>
            <UncustomizableMarkup>
              <MemoizedReactMarkdown>{shippingContent}</MemoizedReactMarkdown>
            </UncustomizableMarkup>
          </ModalDialogBody>
        </ModalDialogContent>
      </ModalDialog>
    </FlexBox>
  );
};

export default ShippingExclusion;
